module.exports = __webpack_public_path__ + "static/media/jelena-stankovic.dca098d6.jpg";